import React from 'react';
import {Grid} from '@mantine/core';
import {useFormikContext} from "formik";
import Divider from "@material-ui/core/Divider";
import MantineDateField from "../../../../FormikUtils/MantineDateField";
import MantineSelectField from "../../../../FormikUtils/MantineSelectField";
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import MantineDependantField from "../../../../FormikUtils/MantineDependantField";
import moment from "moment";

export default function PolizaForm(props) {
    const {
        formField: {
            vigenciaDesde,
            vigenciaHasta,
            formaDePago,
            infoDePago: {
                numeroCbu,
                marcaTarjeta,
                numeroTarjeta,
            },
        }
    } = props;
    const {values} = useFormikContext();

    const formasDePago = [
        // {value: '0', label: 'Efectivo'},
        {value: '4', label: 'Débito por CBU'},
        {value: '2', label: 'Tarjeta de crédito'}
    ];

    const idsTarjeta = [
        {value: '1', label: 'Cabal'},
        {value: '5', label: 'Visa'},
        {value: '7', label: 'Favacard'},
        {value: '9', label: 'American Express'},
        {value: '12', label: 'Naranja'},
        {value: '16', label: 'Diners Club'},
        {value: '18', label: 'Naranja Visa'},
        {value: '20', label: 'Cordobesa - Matercard'},
        {value: '23', label: 'TDF - Tierra del Fuego'},
        {value: '45', label: 'Mastercard Nueva'},
        {value: '57', label: 'ELEBAR'},
        {value: '70', label: 'Censosud  Mastercard'},
    ];

    const calculateVigenciaHasta = () => {
        if (values.frecuenciaPago === "5") {
            return moment(values.vigenciaDesde, "YYYY-MM-DD").add(1, "Y").toDate()
        } else {
            return moment(values.vigenciaDesde, "YYYY-MM-DD").add(6, "M").toDate()
        }
    }

    const formatVigenciaDisplay = (toConvert) => {
        return moment(toConvert, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">
                <Grid.Col xs={12} sm={6}>
                    <MantineDateField
                        name={vigenciaDesde.name}
                        label={vigenciaDesde.label}
                        allowFreeInput={false}
                    />
                </Grid.Col>
                <Grid.Col xs={12} sm={6}>
                    <MantineDependantField
                        dependantField={vigenciaHasta}
                        dependsOn={vigenciaDesde}
                        dependsOnTwo={null}
                        calculateValueFunction={calculateVigenciaHasta}
                        formatDisplay={formatVigenciaDisplay}
                        allowFreeInput={false}
                        disabled
                    />
                </Grid.Col>

                <Grid.Col xs={12} sm={12} style={{margin: "8px 0"}}>
                    <Divider variant="middle"/>
                </Grid.Col>

                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={formaDePago.name}
                        label={formaDePago.label}
                        data={formasDePago}
                    />
                </Grid.Col>

                <Grid.Col xs={12} sm={6}/>

                {values.formaDePago === '2' && (
                    <>

                        <Grid.Col xs={12} sm={6}>
                            <MantineSelectField
                                name={`infoDePago.${marcaTarjeta.name}`}
                                label={marcaTarjeta.label}
                                data={idsTarjeta}
                            />
                        </Grid.Col>
                        <Grid.Col xs={12} sm={6}>
                            <MantineInputField
                                name={`infoDePago.${numeroTarjeta.name}`}
                                label={numeroTarjeta.label}
                            />
                        </Grid.Col>
                    </>
                )}
                {values.formaDePago === '4' && (
                    <>
                        <Grid.Col xs={12} sm={6}>
                            <MantineInputField
                                name={`infoDePago.${numeroCbu.name}`}
                                label={numeroCbu.label}
                            />
                        </Grid.Col>

                        <Grid.Col xs={12} sm={6}/>
                    </>
                )}
            </Grid>
        </React.Fragment>
    );
}
